import React, { Component } from "react";
import ReactDOM from 'react-dom';
import { func, bool } from 'prop-types';
import ImgCheckCircleFilled from 'Atoms/ImgCheckCircleFilled';
import Currency from 'react-currency-formatter';
import * as _ from 'lodash';
import bowser from 'bowser';


// TODO: REWRITE CODE USING REFS INSTEAD OF DOCUMENT
// TODO: REWRITE PAYOPTIONS PROPS



class PayOptions extends Component {
    constructor(props){
      super(props)
      this.state = {
        noAmountIndicator: false,
        resetCustomAmount: false
      }
      // Debounce the update to avoid firing on every keystroke
    this.debouncedUpdate = _.debounce(() => {
      this.updateAccount(this.props.accounts);
    }, 500); // Wait 500ms after user stops typing
    }

    componentDidMount(){
      //CHECK FOR IE
      if (bowser.msie ||  bowser.msedge) {
        this.props.actions.isIEFlag(true);
      }
      let billingAccount = this.props.accounts[this.props.props.account.account_number];
      let selDate = billingAccount.minimum_due_date;

      let differenceInDays = this.calculateDays(selDate);
      let selectedIndicatorBool = ( differenceInDays > 30 ) ? true : false;

      this.setState({
        noAmountIndicator: selectedIndicatorBool
      });

      this.removeClasses(this.props.props.account.account_number);


      _.forEach(this.props.accounts, (value, key) => {
        let selection = value.paymentOption;
        if(selection){
          let element;
          if(selection === "min"){
            element=document.getElementById(`amount_due${key}`);
          } else if (selection === "Full payment") {
            element=document.getElementById(`pf${key}`);
          } else if (selection === "Other amount") {
            element=document.getElementById(`pc${key}`);
          } else if (selection === "No payment") {
            element=document.getElementById(`pn${key}`);
          }
          element && element.classList.add('selected');
        } else {
          let finAmtDue=document.getElementById(`amount_due${key}`);
          finAmtDue && finAmtDue.classList.add('selected');
        }
      })
      this.setState({
        resetCustomAmount: billingAccount.resetCustomAmount
      });
    }

    componentWillReceiveProps(nextProps){
      let oldBillingAccount = this.props.accounts[this.props.props.account.account_number];
      let oldSelDate = oldBillingAccount.minimum_due_date;

      let newSelBillingAccount = nextProps.accounts[nextProps.props.account.account_number];
      let newSelDate = newSelBillingAccount.minimum_due_date;

      //recalculate selectedIndicatorBool if props changes.
      if (newSelDate !== oldSelDate){
        let differenceInDays = this.calculateDays(newSelDate);
        let selectedIndicatorBool = ( differenceInDays > 30 ) ? true : false;

        this.setState({
          noAmountIndicator: selectedIndicatorBool
        })
      }

      _.forEach(nextProps.accounts, (value, key) => {
        let selection = value.paymentOption;
        if(selection){
          let element;
          if(selection === "min"){
            element=document.getElementById(`amount_due${key}`);
          } else if (selection === "Full payment") {
            element=document.getElementById(`pf${key}`);
          } else if (selection === "Other amount") {
            element=document.getElementById(`pc${key}`);
          } else if (selection === "No payment") {
            element=document.getElementById(`pn${key}`)
          }
          element && element.classList.add('selected');
        }
      })

      this.setState({
        resetCustomAmount: newSelBillingAccount.resetCustomAmount
      })
    }


    updateAccount = accountObject => {
        this.props.actions.updateAccountPayment(accountObject);
    };

    updateAmountDue = (billAccNum , passIEFlag)  => {

      if(passIEFlag){
        document.getElementById(('tf'+billAccNum)).disabled = true;
      }

      const amountDueNode = ReactDOM.findDOMNode(this.refs[`amountDue${billAccNum}`]);

        //payment_amount to capture modified/custom amount selected by user.
        this.props.accounts[this.props.props.account.account_number].payment_amount = this.props.accounts[this.props.props.account.account_number].minimum_due_amount;
        this.props.accounts[this.props.props.account.account_number].paymentOption = "min"
        this.props.accounts[this.props.props.account.account_number].resetCustomAmount = true;


        this.updateAccount(this.props.accounts);
        this.removeClasses(billAccNum);
        amountDueNode && amountDueNode.classList.add("selected");

    };

    updatePayInFull = (billAccNum,passIEFlag) => {
      if(passIEFlag){
        document.getElementById(('tf'+billAccNum)).disabled = true;
      }
      const fullPaymentNode = ReactDOM.findDOMNode(this.refs[`full_pay${billAccNum}`]);

        //payment_amount to capture modified/custom amount selected by user.
        if(this.props.accounts[this.props.props.account.account_number].pay_in_full_amount < 0)
            this.props.accounts[this.props.props.account.account_number].payment_amount = 0;
        else
            this.props.accounts[this.props.props.account.account_number].payment_amount = this.props.accounts[this.props.props.account.account_number].pay_in_full_amount;

        this.props.accounts[this.props.props.account.account_number].paymentOption = "Full payment";
        this.props.accounts[this.props.props.account.account_number].resetCustomAmount = true;
        this.updateAccount(this.props.accounts);
        this.removeClasses(billAccNum);
        fullPaymentNode && fullPaymentNode.classList.add("selected");

    };

    updateNone = (billAccNum,passIEFlag) => {

      if(passIEFlag){
        document.getElementById(('tf'+billAccNum)).disabled = true;
      }
        const noAmountNode = ReactDOM.findDOMNode(this.refs[`no_amount${billAccNum}`]);

      this.props.accounts[this.props.props.account.account_number].payment_amount  = 0;
      this.props.accounts[this.props.props.account.account_number].paymentOption = "No payment";
      this.props.accounts[this.props.props.account.account_number].resetCustomAmount = true;
      
      if (this.props.accounts[this.props.props.account.account_number].payment_amount === 0){
					_.forEach(this.props.accounts[this.props.props.account.account_number].policies, policy => {
						policy.policy_amount = 0;
						policy.summaryPolicyData = 0;
					});
				} 
      this.updateAccount(this.props.accounts);
      this.removeClasses(billAccNum);
      noAmountNode && noAmountNode.classList.add("selected");

    }

    removeClasses = (billAccNum) => {
        let amountDueNode = ReactDOM.findDOMNode(this.refs[`amountDue${billAccNum}`]);
        let fullPaymentNode = ReactDOM.findDOMNode(this.refs[`full_pay${billAccNum}`]);
        let otherAmountNode = ReactDOM.findDOMNode(this.refs[`other_amount${billAccNum}`]);
        let noAmountNode = ReactDOM.findDOMNode(this.refs[`no_amount${billAccNum}`]);
        amountDueNode && amountDueNode.classList.remove("selected");
        fullPaymentNode && fullPaymentNode.classList.remove("selected");
        otherAmountNode && otherAmountNode.classList.remove("selected");
        noAmountNode && noAmountNode.classList.remove("selected");
    }

    calculateDays = dateString => {
      // Set the unit values in milliseconds.
      let msecPerMinute = 1000 * 60;
      let msecPerHour = msecPerMinute * 60;
      let msecPerDay = msecPerHour * 24;

      // Set a date and get the milliseconds
      let date = new Date(dateString);
      let todayDate = new Date();
      let dateMsec = date.getTime();
      let todayDateMsec = todayDate.getTime();

      //get time difference
      let differenceInSec = dateMsec - todayDateMsec;
      let differenceInDays = Math.round(differenceInSec / msecPerDay) + 1;
      return differenceInDays;

    }

    handleMinDueKeyUp = (e, billingNumber) => {
      let passIEFlag = this.props.isIEFlag;
      if (e.keyCode === 13) {
        this.updateAmountDue(billingNumber, passIEFlag);
       }
    }

    handleFullPaymentKeyUp = (e, billingNumber) => {
      let passIEFlag = this.props.isIEFlag;
      if (e.keyCode === 13) {
        this.updatePayInFull(billingNumber, passIEFlag);
       }
    }

    handleNoPaymentKeyUp = (e, billingNumber) => {
      let passIEFlag = this.props.isIEFlag;
      if (e.keyCode === 13) {
        this.updateNone(billingNumber, passIEFlag);
      }
    }


    render() {
      let billingAccount = this.props.accounts[this.props.props.account.account_number];
      const billingAccountNumber = this.props.props.account.account_number;
      const passIEFlag =  this.props.isIEFlag;

      let { noAmountIndicator } = this.state;

      //check if any payment option was clicked and select No payment accordingly
      let resetCustomAmountCheck = billingAccount.resetCustomAmount;

        return (
            <div className="payselect-list">
                <div
                  id={"amount_due" + billingAccountNumber}
                  ref={`amountDue${billingAccountNumber}`}
                  onKeyUp={(e) => this.handleMinDueKeyUp(e, billingAccountNumber)}
                  tabIndex="0"
                  className={noAmountIndicator ? "option": "option selected"}
                  onClick={()=>{this.updateAmountDue(billingAccountNumber,passIEFlag)}}>
                    <ImgCheckCircleFilled className="green"/>
                    <ul>
                        <li aria-label="Minimum due">Minimum due</li>
                        <li>
                            <Currency
                                quantity={billingAccount.minimum_due_amount}
                                pattern="!#,##0.00"
                            />

                        </li>
                    </ul>
                </div>
                <div
                  id={"pf" + billingAccountNumber}
                  ref={`full_pay${billingAccountNumber}`}
                  tabIndex="0"
                  onKeyUp={(e)=>{this.handleFullPaymentKeyUp(e, billingAccountNumber)}}
                  className="option"
                  onClick={()=>{this.updatePayInFull(billingAccountNumber,passIEFlag)}}>

                    <ImgCheckCircleFilled className="green"/>

                    <ul>
                        <li aria-label="Full payment balance">Full payment balance</li>
                        <li>
                            <Currency
                                quantity={this.props.accounts[this.props.props.account.account_number].pay_in_full_amount <= 0 ? 0 : this.props.accounts[this.props.props.account.account_number].pay_in_full_amount}
                                pattern="!#,##0.00"
                            />
                        </li>
                    </ul>
                </div>
                <div
                  id={"pn" + billingAccountNumber}
                  ref={`no_amount${billingAccountNumber}`}
                  tabIndex="0"
                  className={resetCustomAmountCheck ? "option" : noAmountIndicator ? "option selected" : "option" }
                  onKeyUp={(e)=>{this.handleNoPaymentKeyUp(e, billingAccountNumber)}}
                  onClick={()=>{this.updateNone(billingAccountNumber,passIEFlag)}}>
                    <ImgCheckCircleFilled className="green"/>
                    <ul>
                        <li aria-label="No payment"> No payment</li>
                        <li>--</li>
                    </ul>
                </div>

            </div>
        );
    }
};



PayOptions.propTypes = {
  updateAccount: func,
  updateAmountDue: func,
  updatePayInFull: func,
  updateNone: func,
  removeClasses: func,
  calculateDays: func,
  noAmountIndicator: bool,
};


export default PayOptions;



// WEBPACK FOOTER //
// ./src/components/atomic/molecules/PayOptions/PayOptions.js